import { addEventToCache } from '@/services/client.service'
import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowReloadHorizontalIcon } from '@hugeicons/core-free-icons'
import { Event, validateEvent } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Notification from './Notification'

export function RepostNotification({
  notification,
  isNew = false
}: {
  notification: Event
  isNew?: boolean
}) {
  const { t } = useTranslation()
  const event = useMemo(() => {
    try {
      const event = JSON.parse(notification.content) as Event
      const isValid = validateEvent(event)
      if (!isValid) return null
      addEventToCache(event)
      return event
    } catch {
      return null
    }
  }, [notification.content])
  if (!event) return null

  return (
    <Notification
      notificationId={notification.id}
      icon={<HugeiconsIcon icon={ArrowReloadHorizontalIcon} size={24} className="text-green-400" />}
      sender={notification.pubkey}
      sentAt={notification.created_at}
      targetEvent={event}
      description={t('reposted your note')}
      isNew={isNew}
    />
  )
}
